export default {
  name: 'Navigation'
}
